import React, { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

export const AlshayaContext = createContext();

export const AlshayaProvider = ({ children }) => {
  const [searchClicked, setSearchClicked] = useState(false);
  const [productData, setProductData] = useState([]);
  const [articleData, setArticleData] = useState([]);
  const [channel, setChannel] = useState([]);
  const [season, setSeason] = useState([]);
  const [inshopWeek, setInshopWeek] = useState([]);
  const [sTermLength, setSTermLength] = useState();
  const [countLoading, setCountLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("");
  const [checkValue, setCheckValue] = useState(false);
  const [productCountData, setProductCountData] = useState([]);
  const [articleCountData, setArticleCountData] = useState([]);
  const [isNotFound, setIsNotFound] = useState(false);
  const [activeKey, setActiveKey] = useState(1);
  const [activeIndex, setActiveIndex] = useState(null);
  const [summaryPageData, setSummaryPageData] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [payLoad, setPayLoad] = useState();
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [hoveredLegend, setHoveredLegend] = useState(null);
  const [initialProductCountData, setInitialProductCountData] = useState([]);
  const [initialArticleCountData, setInitialArticleCountData] = useState([]);
  const [filterCountLoading, setFilterCountLoading] = useState(false);
  const value = useMemo(
    () => ({
      searchClicked,
      setSearchClicked,
      productData,
      setProductData,
      articleData,
      setArticleData,
      channel,
      setChannel,
      season,
      setSeason,
      inshopWeek,
      setInshopWeek,
      sTermLength,
      setSTermLength,
      loading,
      setLoading,
      type,
      setType,
      checkValue,
      setCheckValue,
      productCountData,
      setProductCountData,
      articleCountData,
      setArticleCountData,
      countLoading,
      setCountLoading,
      isNotFound,
      setIsNotFound,
      activeKey,
      setActiveKey,
      activeIndex,
      setActiveIndex,
      summaryPageData,
      setSummaryPageData,
      payLoad,
      setPayLoad,
      showMore,
      setShowMore,
      summaryLoading,
      setSummaryLoading,
      hoveredLegend,
      setHoveredLegend,
      initialProductCountData,
      setInitialProductCountData,
      initialArticleCountData,
      setInitialArticleCountData,
      filterCountLoading,
      setFilterCountLoading,
    }),
    [
      searchClicked,
      productData,
      articleData,
      channel,
      season,
      inshopWeek,
      sTermLength,
      loading,
      type,
      checkValue,
      productCountData,
      articleCountData,
      countLoading,
      isNotFound,
      activeKey,
      activeIndex,
      summaryPageData,
      payLoad,
      showMore,
      summaryLoading,
      hoveredLegend,
      initialProductCountData,
      initialArticleCountData,
      filterCountLoading,
    ]
  );

  return (
    <AlshayaContext.Provider value={value}>
      {children}
    </AlshayaContext.Provider>
  );
};
AlshayaProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

